<span>{{dates | date: formatDate}}</span>
{{dates | date: formatTime}} {{"timeStamp" | translate}}